import { render, staticRenderFns } from "./ModalContentAddDocument.vue?vue&type=template&id=00a72b17&"
import script from "./ModalContentAddDocument.vue?vue&type=script&lang=js&"
export * from "./ModalContentAddDocument.vue?vue&type=script&lang=js&"
import style0 from "./ModalContentAddDocument.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports